var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInboxIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.23 13.357l-2.304-11C18.616.995 17.552 0 16.355 0H4.92C3.723 0 2.66.995 2.35 2.357l-2.306 11C0 13.462 0 13.514 0 13.62v5.238C0 20.586 1.197 22 2.66 22h15.955c1.463 0 2.66-1.414 2.66-3.143V13.62c0-.105 0-.157-.045-.262zM4.078 2.881c.088-.471.443-.786.842-.786h11.435c.399 0 .753.315.842.786l2.039 9.69h-5.053c-.487 0-.886.472-.886 1.048v1.048c0 .576-.4 1.047-.887 1.047H8.864c-.487 0-.886-.471-.886-1.047v-1.048c0-.576-.399-1.048-.886-1.048H2.039l2.039-9.69zm14.537 17.024H2.66c-.487 0-.886-.472-.886-1.048v-4.19h4.432c0 1.728 1.197 3.143 2.66 3.143h3.545c1.463 0 2.66-1.415 2.66-3.143h4.432v4.19c0 .576-.4 1.048-.887 1.048z",
    transform: "translate(-16 -129) translate(16 128) translate(0 1)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInboxIcon);
export default __webpack_public_path__ + "static/media/inboxIcon.6d89e0ee7d74e3d332f6e92b6326972d.svg";
export { ForwardRef as ReactComponent };